import Drawer from 'react-modern-drawer';
import { IoClose } from "react-icons/io5";
import { FaFolder } from "react-icons/fa";
import { useDashboard } from '../../../context/DashboardContext';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { set_active_conversation } from '../../../redux/messageSlice';
import { useSelector } from 'react-redux';

const FlaggedSideBarList = ({ flaggedProjectSidebar, setFlaggedProjectSidebar, type }) => {
    const dispatch = useDispatch()
    const { active_conversation } = useSelector(state => state.message);
    const { conversations, totalFlaggedItems } = useDashboard();
    const uniqueArr = [...new Set(totalFlaggedItems?.[type])];
    useEffect(() => {
        if (uniqueArr.length > 0) {
            dispatch(set_active_conversation(conversations?.filter(f => f.conversation_id === uniqueArr[0])[0]));
        }
    }, [])


    return (
        <Drawer
            open={flaggedProjectSidebar}
            onClose={() => setFlaggedProjectSidebar(false)}
            direction="left"
            enableOverlay={true}
            className='!h-full !w-[63%] !bg-white dark:!bg-[#131313]'
            overlayClassName='customOverlay'
        >
            <div className="h-full flex flex-col">
                {/* Header */}
                <div className='flex items-center justify-between py-3 px-3 border-b dark:border-gray-700'>
                    <div className='text-base font-semibold text-teal-800 dark:text-white'> Rooms </div>
                    <button
                        onClick={() => setFlaggedProjectSidebar(false)}
                        className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700"
                    >
                        <IoClose className='text-xl text-teal-600 dark:text-white' />
                    </button>
                </div>

                {/* Project List */}
                <div className='flex-1 overflow-y-auto'>
                    {conversations?.filter(f => uniqueArr.includes(f.conversation_id))?.map(c => (
                        <div
                            key={c.conversation_id}
                            onClick={() => {
                                dispatch(set_active_conversation(c));
                                setFlaggedProjectSidebar(false);
                            }}
                            className={`flex items-center gap-2 py-3 px-3 border-b border-teal-200 cursor-pointer
                                ${active_conversation?.conversation_id === c.conversation_id ? 'bg-teal-200' : ''}`}
                        >
                            <FaFolder className='text-lg text-teal-600' />
                            <p className='text-sm text-teal-600 dark:text-gray-200'>
                                {c.title}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </Drawer>
    );
};

export default FlaggedSideBarList;
